const DeleteConfirmation = (props) => {
    return <div>
        <p>
            Are you sure you want to delete?
        </p>
    </div>
};

export default DeleteConfirmation;